<template>
  <div class="dj">
    <VideoBanner v-if='$route.name === "DJ"' posterSrc='dj.jpg' mp4Src='dj.mp4' webmSrc='dj.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>DJ</h2>
        <div class="dj-content page-content">
          <b-row>
            <b-col>
              <h3>Rätt DJ skapar rätt stämning</h3>
              <p>Musiken sätter tonen för hela kvällen  och en duktig DJ vet precis hur man får gästerna att trivas. Vi erbjuder erfarna DJ:s för allt från bröllop och födelsedagsfester till företagsevent och galor.</p>
              <h3>Enkel bokning. Komplett upplevelse.</h3>
              <p>Vi hjälper dig med hela paketet: DJ, ljud, ljus och teknik allt anpassat efter ditt event. Du berättar vad du vill uppnå, vi löser resten.</p>
              <h3>Musik som passar dig och din publik</h3>
              <p>Oavsett genre eller stil anpassar vi musiken efter dina önskemål och gästerna på plats. Från avslappnad mingelmusik till fullt dansgolv.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
